/**
 * @owner @Appboy/in-app-messages
 */

import { z } from "zod";

export const grapesJsDataSchema = z.any();
